import { orgQueryKeys } from 'src/queries/queries.constants'
import {
  ExtendBaseQueryOptions,
  useExtendQuery,
} from 'src/queries/queries.utils'

import { VirtualCardTypesResponse } from './virtualCardTypes.types'

interface OrganizationVirtualCardTypesOptions
  extends ExtendBaseQueryOptions<VirtualCardTypesResponse, string[]> {
  orgId: string | undefined
}

export const useQueryOrganizationVirtualCardTypes = ({
  orgId,
  enabled = true,
  ...rest
}: OrganizationVirtualCardTypesOptions) => {
  return useExtendQuery<VirtualCardTypesResponse, string[]>({
    queryKey: orgQueryKeys.virtualCardTypes(orgId),
    queryUrl: () => `/organizations/${orgId}/virtualcardtypes`,
    select: (data) => data.virtualCardTypes,
    enabled: enabled && !!orgId,
    ...rest,
  })
}
